import { render, staticRenderFns } from "./BaseRangeSlider.vue?vue&type=template&id=c0db860e&scoped=true&"
import script from "./BaseRangeSlider.vue?vue&type=script&lang=js&"
export * from "./BaseRangeSlider.vue?vue&type=script&lang=js&"
import style0 from "./BaseRangeSlider.vue?vue&type=style&index=0&id=c0db860e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c0db860e",
  null
  
)

export default component.exports